module.exports = __webpack_public_path__ + "static/media/ArrowRight.b4426e87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ArrowRight.svg
// module id = 1043
// module chunks = 0